import type { NicheConfig } from "../../types/niche";

export const saldoRetidoConfig: NicheConfig = {
  id: "niche-saldo-retido",
  slug: "saldo-retido",
  name: "Liberação de Saldo Retido em Gateways e Marketplaces",
  metaTitle: "Saldo Retido em Gateway ou Marketplace | Notificação Extrajudicial Lei 12.865/13 | Gepeto",
  metaDescription:
    "Gere uma notificação extrajudicial para exigir a liberação de saldo retido por Mercado Pago, PagBank, Stone, Stripe e outras instituições de pagamento, com fundamento na Lei nº 12.865/13 e normas do Banco Central.",
  badge: "Notificação Extrajudicial - Lei nº 12.865/13",
  headline: "Recupere seu Saldo Retido em Gateways e Marketplaces",
  subheadline:
    "Gere sua Notificação Extrajudicial fundamentada na Lei nº 12.865/13 e nas normas do Banco Central, exigindo a liberação integral dos valores bloqueados dentro do limite cautelar regulamentar de até 72 horas (Resolução BCB nº 150/2021).",
  targetPain:
    "Vendas aprovadas, mercadoria entregue e o saldo segue bloqueado sem prazo nem explicação clara? A retenção prolongada compromete seu capital de giro e a operação do seu negócio.",
  price: 97,
  formFields: [
    {
      name: "instituicao",
      label: "Instituição / Gateway",
      type: "select",
      placeholder: "Selecione a instituição",
      required: true,
      step: 1,
      options: ["Mercado Pago", "PagBank", "ShopeePay", "Stripe", "Stone/Ton", "InfinitePay", "Asaas Gestão Financeira", "Outro"],
    },
    {
      name: "instituicaoOutra",
      label: "Nome da Instituição",
      type: "text",
      placeholder: "Nome comercial ou razão social",
      required: true,
      step: 1,
      dependsOn: { field: "instituicao", value: "Outro" },
    },
    { name: "valorBloqueado", label: "Valor Bloqueado (R$)", type: "currency", placeholder: "0,00", required: true, step: 1 },
    { name: "dataBloqueio", label: "Data do Bloqueio", type: "date", required: true, step: 1 },
    {
      name: "motivoAlegado",
      label: "Motivo Alegado pela Instituição",
      type: "textarea",
      placeholder: "Ex.: análise de segurança, suspeita de fraude, chargebacks, sem justificativa...",
      required: true,
      step: 1,
      maxLength: 500,
    },
    { name: "identificadorConta", label: "E-mail de contato para notificação", type: "email", placeholder: "seuemail@empresa.com.br", required: true, step: 1 },
    {
      name: "tipoTitular",
      label: "Tipo de Titular",
      type: "radio",
      required: true,
      step: 2,
      options: ["PJ", "PF"],
      optionLabels: { PJ: "Pessoa Jurídica (CNPJ)", PF: "Pessoa Física (CPF)" },
    },
    { name: "razaoSocialOuNome", label: "Razão Social ou Nome Completo", type: "text", placeholder: "Como consta no cadastro da instituição", required: true, step: 2 },
    { name: "documentoTitular", label: "CPF / CNPJ", type: "document", placeholder: "00.000.000/0000-00", required: true, step: 2 },
    { name: "email", label: "E-mail", type: "email", placeholder: "voce@empresa.com.br", required: true, step: 2 },
    { name: "whatsapp", label: "WhatsApp", type: "tel", placeholder: "(00) 00000-0000", required: true, step: 2 },
    {
      name: "aceite",
      label: "Li e aceito os Termos de Uso e declaro que as informações são verdadeiras",
      type: "checkbox",
      required: true,
      step: 2,
    },
  ],
};
